import React from 'react';

import { CalloutV2, Intent } from '@varicent/components';

import { ExternalLink } from 'app/components/ExternalLink/ExternalLink';

import { SplitFeatures } from 'app/global/features';

import useTreatment from 'app/hooks/useTreatment';

import block from 'utils/bem-css-modules';
import { formatMessage } from 'utils/messages/utils';

import style from './MaintenanceBanner.module.pcss';

const b = block(style);

interface MaintenanceBannerProps {
  customMessage?: string;
}

interface TemporaryActivityImportMaintenanceBannerProps {
  messageKey: 'MAINTENANCE_MESSAGE_BC_AND_MANAGE' | 'MAINTENANCE_MESSAGE_STATUS_MENU';
}

export const TemporaryActivityImportMaintenanceBanner: React.FC<TemporaryActivityImportMaintenanceBannerProps> = ({
  messageKey
}) => {
  const [_isEnabled, { config: splitConfig }] = useTreatment(SplitFeatures.MAINTENANCE_BANNERS);

  if (!splitConfig) {
    return null;
  }

  let maintenanceEndTime: string;

  try {
    const parsedConfig = JSON.parse(splitConfig);
    maintenanceEndTime = parsedConfig.maintenanceEndTime;
  } catch {
    return null;
  }

  const formattedMessage = formatMessage(messageKey, {
    maintenanceEndTime: maintenanceEndTime || 'TBD'
  });
  return <MaintenanceBanner customMessage={formattedMessage} />;
};

const MaintenanceBanner: React.FC<MaintenanceBannerProps> = ({ customMessage }) => {
  const [_isEnabled, { config: splitConfig }] = useTreatment(SplitFeatures.MAINTENANCE_BANNERS);

  if (!splitConfig) {
    return null;
  }

  let parsedConfig;
  try {
    parsedConfig = JSON.parse(splitConfig);
  } catch {
    return null;
  }

  const { title, message, url, intent } = parsedConfig;

  if (!title || !message) {
    return null;
  }

  return (
    <div className={b()} data-testid="maintenance-banner">
      <CalloutV2 intent={intent ?? Intent.WARNING} title={title}>
        <div className={b('bannerMessage')} data-testid="banner-message">
          {customMessage || message}
        </div>
        {url && <ExternalLink linkText={formatMessage('LEARN_MORE')} url={url} />}
      </CalloutV2>
    </div>
  );
};

export default MaintenanceBanner;
